import Dashboard from "./Pages/DashboardComponent";
import UserProfile from "./Pages/Users/UserProfile";
import Users from "./Pages/Users/Users";
import MerchantDashboard from "./Pages/MerchantDashboard";
import RequestLogsComponent from "./Pages/RequestLogsComponent";
import KycSubmissionComponent from "./Pages/Kyc/KycSubmissions";
import CreateMerchant from "./Pages/Merchants/CreateMerchant";
import Merchants from "./Pages/Merchants/Merchants";
import Tariffs from "./Pages/Tariffs";
import MerchantDetails from "./Pages/Merchants/MerchantDetails";
import UsersAdministration from "./Pages/Users/UsersAdministration";
import UpdateOperator from "./Pages/Users/UpdateOperator";
import CreateOperatorComponent from "./Pages/Users/CreateOperator";
import MassPayments from "./Pages/MassPayments/MassPayments";
import ConfidentialClients from "./Pages/ConfidentialClients/ConfidentialClients";
import ApiScopes from "./Pages/ApiScopes/ApiScopes";
import { isCRMAllAllowed, isKYCApproveAllowed, isKYCAssessAllowed, isMerchantAllAllowed, isSuperAdmin, isMassPaymentExecutorAllowed, isKycSubmissionViewAllowed, isNotificationsAllowed, isBoricaTransactionsAllowed, isOperationOfficer } from "./authGuard";
import JournalingComponent from "./Pages/JournalingComponent";
import ReviewBankTransfersOutgoing from "./Pages/Compliance/ReviewBankTransfersOutgoing";
import { storageService } from "./services/StorageService";
import RegisteredUserProfile from "./Pages/Users/RegisteredUserProfile";
import { UserPermissions } from "./models/AppConstants";
import ICardClientDetailsComponent from "./Pages/Issuing/ICardClientDetails";
import ICardDetailsComponent from "./Pages/Issuing/CardDetails";
import IssuingComponent from "./Pages/Issuing/Index";
import FileDetailsComponent from "./Pages/Issuing/Reporting/reportDetails";
import { NotificationHub } from "./Pages/Notifications";
import FastPayTransactions from "./Pages/Transactions/FastPayTransactions";
import CashOperations from "./Pages/Operations/CashOperations";

export interface Route {
  label: string;
  icon?: string;
  path: string;
  component: any;
  componentProps: object;
  permissionName: string | string[];
  visibleInNav: boolean;
}
const checkIsMerchantAllAllowed = isMerchantAllAllowed();

export const routes: Route[] = [
  {
    label: "Dashboard",
    icon: "faDashboard",
    path: "/dashboard",
    component: Dashboard,
    componentProps: {},
    permissionName: UserPermissions.DashboardAllowed,
    visibleInNav: true,
  },
  {
    label: "Merchant Dashboard",
    icon: "faDashboard",
    path: "/merchantdashboard",
    component: MerchantDashboard,
    componentProps: {},
    permissionName: UserPermissions.MerchantDashboardAllowed,
    visibleInNav: !checkIsMerchantAllAllowed,
  },
  {
    label: "Customers",
    icon: "faUserGroup",
    path: "/users",
    component: Users,
    componentProps: { merchantId: 1 },
    permissionName: [UserPermissions.CRMUserAllowed, UserPermissions.LeadsPermissionAll],
    visibleInNav: true,
  },
  {
    label: "Issuing",
    icon: "faIdCard",
    path: "/issuing",
    component: IssuingComponent,
    componentProps: { merchantId: 1 },
    permissionName: [UserPermissions.MerchantProfileUpdateAllowed],
    visibleInNav: true,
  },
  {
    label: "",
    path: "/issuing/individualId/:id",
    component: ICardClientDetailsComponent,
    componentProps: {},
    permissionName: UserPermissions.MerchantViewDetailAllowed,
    visibleInNav: false,
  },
  {
    label: "",
    path: "/issuing/file-details/:id",
    component: FileDetailsComponent,
    componentProps: {},
    permissionName: UserPermissions.MerchantViewDetailAllowed,
    visibleInNav: false,
  },
  {
    label: "",
    path: "/issuing/card/:cardId/:individualId",
    component: ICardDetailsComponent,
    componentProps: {},
    permissionName: UserPermissions.MerchantViewDetailAllowed,
    visibleInNav: false,
  },
  {
    label: "",
    path: "/lead-profile/:id",
    component: RegisteredUserProfile,
    componentProps: {},
    permissionName: [UserPermissions.UserProfileViewDetailsAllowed, UserPermissions.LeadsPermissionAll],
    visibleInNav: false,
  },
  {
    label: "",
    path: "/user-profile/:id",
    component: UserProfile,
    componentProps: {},
    permissionName: UserPermissions.UserProfileViewDetailsAllowed,
    visibleInNav: false,
  },
  {
    label: "Tariffs and Currencies",
    icon: "faMoneyBillWave",
    path: "/tariffs",
    component: Tariffs,
    componentProps: {},
    permissionName: UserPermissions.MerchantAllowed,
    visibleInNav: true,
  },
  {
    // Cash Operations — cash-in deposits list + retry (TNPDEVAPPS-1755).
    // Visible only to Super Admin or Operation Officer (like the other role-gated menus).
    label: "Cash Operations",
    icon: "faMoneyBillWave",
    path: "/cash-operations",
    component: CashOperations,
    componentProps: {},
    permissionName: UserPermissions.OperationsAllowed,
    visibleInNav: isSuperAdmin() || isOperationOfficer(),
  },
  {
    label: checkIsMerchantAllAllowed ? "Merchants" : "Merchant Profile",
    icon: "faUserGroup",
    path: checkIsMerchantAllAllowed ? "/merchants" : `/merchant/${storageService.getSelectedMerchantId()}`,
    component: checkIsMerchantAllAllowed ? Merchants : MerchantDetails,
    componentProps: {},
    permissionName: UserPermissions.MerchantAllowed,
    visibleInNav: true,
  },
  {
    label: "",
    path: "/merchant/create",
    component: CreateMerchant,
    componentProps: {},
    permissionName: UserPermissions.MerchantCreateNewAllowed,
    visibleInNav: false,
  },
  {
    label: "",
    path: "/merchant/:id",
    component: MerchantDetails,
    componentProps: {},
    permissionName: UserPermissions.MerchantViewDetailAllowed,
    visibleInNav: false,
  },
  {
    label: "Notifications",
    icon: "faBell",
    path: "/notifications",
    component: NotificationHub,
    componentProps: {},
    permissionName: UserPermissions.MerchantAllowed,
    visibleInNav: isNotificationsAllowed(),
  },
  {
    label: "Kyc",
    icon: "faUserLock",
    path: "/kyc",
    component: KycSubmissionComponent,
    componentProps: {},
    permissionName: UserPermissions.KycSubmissionViewAllowed,
    visibleInNav: isKycSubmissionViewAllowed(),
  },
  {
    label: "Review Bank Transfers",
    icon: "faBank",
    path: "/Compliance",
    component: ReviewBankTransfersOutgoing,
    componentProps: {},
    permissionName: UserPermissions.KycSubmissionViewAllowed,
    visibleInNav: isKYCApproveAllowed() || isKYCAssessAllowed(),
  },
  {
    label: "Journaling",
    icon: "faJournalWhills",
    path: "/journaling",
    component: JournalingComponent,
    componentProps: {},
    permissionName: UserPermissions.JournalingAllowed,
    visibleInNav: isSuperAdmin(),
  },
  {
    label: "Access Logs",
    icon: "faColonSign",
    path: "/accesslogs",
    component: RequestLogsComponent,
    componentProps: {},
    permissionName: UserPermissions.JournalingAllowed,
    visibleInNav: isSuperAdmin(),
  },
  {
    label: "Mass Payments",
    icon: "faMoneyBillTransfer",
    path: "/mass-payments",
    component: MassPayments,
    componentProps: {},
    permissionName: UserPermissions.MassPaymentExecutorAllowed,
    visibleInNav: isMassPaymentExecutorAllowed() || isSuperAdmin(),
  },
  {
    label: "FastPay Transactions",
    icon: "faReceipt",
    path: "/fastpay-transactions",
    component: FastPayTransactions,
    componentProps: {},
    permissionName: UserPermissions.BoricaTransactionsViewAllowed,
    visibleInNav: isBoricaTransactionsAllowed(),
  },
  {
    label: "User Administration",
    icon: "faUserGroup",
    path: "/useradministration",
    component: UsersAdministration,
    componentProps: {},
    permissionName: UserPermissions.OperatorsAndRolesViewUserAllowed,
    visibleInNav: isCRMAllAllowed(),
  },
  {
    label: "Confidential Clients",
    icon: "faKey",
    path: "/confidential-clients",
    component: ConfidentialClients,
    componentProps: {},
    permissionName: UserPermissions.ConfidentialClientsViewAllowed,
    visibleInNav: isSuperAdmin(),
  },
  {
    label: "API Scopes",
    icon: "faLayerGroup",
    path: "/api-scopes",
    component: ApiScopes,
    componentProps: {},
    permissionName: UserPermissions.ApiScopesViewAllowed,
    visibleInNav: isSuperAdmin(),
  },
  {
    label: "User Administration",
    path: "/profile/:id",
    component: UpdateOperator,
    componentProps: {},
    permissionName: UserPermissions.OperatorsAndRolesUpdateOperatorAllowed,
    visibleInNav: false,
  },
  {
    label: "User Administration",
    path: "/profile/create",
    component: CreateOperatorComponent,
    componentProps: { create: true },
    permissionName: UserPermissions.OperatorsAndRolesViewUserAllowed,
    visibleInNav: false,
  },
];


export const OperationNav = [
  {
    label: "All Transactions",
    icon: "faList",
    to: "/all-transactions",
  },

  {
    label: "SFTP Files Exchanged",
    icon: "faList",
    to: "sftp-files-exchanged",
  },
];
